import { useSelector } from "react-redux";
import type { ILiteTradeAssetSymbol } from "../../LiteTrade/types/liteTradeReducer.t";
import { makeSelectLiteTradeMarketDataBySymbol, 
     makeSelectorGetLiteTradeAssetInfoPricePrecision } from "../../LiteTrade/liteTradeSelectors";

import React from "react";
import { IMobileAppRootState } from "../../../mobileAppCore/types/mobileAppState.t";
import { getCurrentPriceFromMarket } from "../../../mobileAppCore/components/MobilePosition/hooks/helpers";

interface AssetRelevantPriceProps {
    symbol: ILiteTradeAssetSymbol,
    withSpread: boolean,
    pendingPrice?: number,
}
export const AssetRelevantPrice: React.FC<AssetRelevantPriceProps> = (props) => {
    const { symbol, withSpread, pendingPrice } = props;
    const getDataSymbol = makeSelectLiteTradeMarketDataBySymbol(symbol);
    const getLiteTradeAssetInfoPricePrecision = makeSelectorGetLiteTradeAssetInfoPricePrecision(symbol);
    const currentPrice = useSelector((state: IMobileAppRootState) => {
        const precision = getLiteTradeAssetInfoPricePrecision(state);
        if (typeof pendingPrice === 'number') {
            return pendingPrice.toFixed(precision) 
        }
        const marketDataSymbol = getDataSymbol(state);
        const currentPrice = getCurrentPriceFromMarket(marketDataSymbol, withSpread);
        return (typeof currentPrice === 'number' ? currentPrice.toFixed(precision) : '');
    });
    return <>{`${currentPrice}`}</>;
}